import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconVSign = ({ color = "#5678EF" }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 7L5.5 11.5L15.5 1.5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    </div>
);